import { normalizeFetchLayerPatternsResponse } from './utils/normalizers/pattern.normalizers'
import { createTagsForList, PATTERN_TAG } from './utils/tags'
import baseApi from './base.api'

export const patternApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchLayerPatterns: builder.query({
            query: ({ token, layerId }) => ({
                url: `/patterns/${token}`,
                method: 'GET',
                params: {
                    layer_id: layerId,
                },
            }),
            transformResponse: normalizeFetchLayerPatternsResponse,
            providesTags: result => createTagsForList(result, PATTERN_TAG),
        }),
        reorderPatterns: builder.mutation({
            query: ({ token, layerId, idToOrderMap }) => ({
                url: `/patterns/reorder/${token}/${layerId}`,
                method: 'PATCH',
                body: idToOrderMap,
            }),
            invalidatesTags: [{ type: PATTERN_TAG, id: 'LIST' }],
        }),
    }),
})

export const { useFetchLayerPatternsQuery, useReorderPatternsMutation } = patternApi
